const convertFromBase64 = (base64String) => {
    // Decode base64 string
    const binaryString = window.atob(base64String);

    // Convert binary string to array buffer
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    const arrayBuffer = bytes.buffer;

    // Create blob
    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

    const archivo = new File([blob], "ticket.pdf", { type: 'application/pdf' });

    return archivo;

    // Create URL for the blob
    // const url = URL.createObjectURL(blob);
    // console.log(url);

    // Open PDF in a new window
    // window.open(url);
    // return url;
}

export default convertFromBase64;